<template>
    <div class="vrm-modal vrm-modal--center mfp-with-anim vrm-modal--file-upload">
        <div>
            <div class="vrm-file-modal__form vrm-modal__content">
                <div class="vrm-modal__title-icon sg-vrm-icon_086_upload-16px"></div>
                <div class="vrm-modal__title">{{ $t('upload.title_firmware_vff') }}</div>
                <div class="vrm-modal__text">{{ $t('upload.message_firmware_vff') }}</div>
                <p class="vrm-modal__text">
                    {{
                        $t('firmware-update.message_selected_product', {
                            i18nFallback: 'Selected product:',
                        })
                    }}
                    <br />
                    <strong>{{ deviceName }}</strong>
                </p>
                <div v-if="hasIds" class="vrm-chip__container vrm-chip__container--center">
                    <div v-for="id in ids" :key="id" class="vrm-chip">
                        {{ id }}
                    </div>
                </div>
                <div class="vrm-file-picker__container">
                    <vrm-file-picker-field
                        v-for="id in ids"
                        :key="id"
                        :label="
                            $t('firmware-update.productid', { i18nFallback: 'Product id:' }) +
                                ': ' +
                                id
                        "
                        :accepted-file-types="acceptedFileTypes"
                        placeholder="Select a file"
                        :action-text="
                            $t('firmware-update.upload-file', { i18nFallback: 'Upload file' })
                        "
                        @change="onFileChanged(id, $event)"
                    />
                </div>
                <div class="vrm-modal__actions sg-spread">
                    <button type="reset" class="sg-btn sg-site" @click="onClose">
                        {{ $t('common.cancel', { i18nFallback: 'Cancel' }) }}
                    </button>
                    <button
                        type="button"
                        class="sg-btn sg-blue vrm-modal__main-button"
                        :disabled="!isCompleted"
                        @click="onSubmit"
                    >
                        {{
                            $t('firmware-update.button_update_firmware', {
                                i18nFallback: 'Update firmware',
                            })
                        }}
                    </button>
                </div>
            </div>

            <modal-close-handle />
        </div>
    </div>
</template>

<style scoped lang="less"></style>

<script>
import { Component, Prop, Vue } from 'vue-property-decorator';
import ModalCloseHandle from '@/vue/components/modals/ModalCloseHandle';
import VrmDropdown from '@/vue/components/shared/VrmDropdown';
import VrmAvatarStack from '@/vue/components/shared/VrmAvatarStack';
import VrmAvatar from '@/vue/components/shared/VrmAvatar';
import { AngularLocaleBundle } from '@/angular-bridge/modules/i18n';
import VrmForm from '@/vue/components/forms/VrmForm';
import VrmTextField from '@/vue/components/forms/VrmTextField';
import VrmTextArea from '@/vue/components/forms/VrmTextArea';
import VrmFilePickerField from '@/vue/components/forms/VrmFilePickerField';

@Component({
    components: {
        VrmTextArea,
        VrmTextField,
        VrmForm,
        VrmAvatar,
        VrmAvatarStack,
        VrmDropdown,
        ModalCloseHandle,
        VrmFilePickerField,
    },
})
@AngularLocaleBundle('common')
@AngularLocaleBundle('upload')
@AngularLocaleBundle('firmware-update')
export default class FirmwareFileUploadModal extends Vue {
    @Prop({ type: Object, default: {}, required: true })
    device;

    @Prop({ type: Array, default: null })
    acceptedFileTypes;

    selectedFiles = {};

    isCompleted = false;

    get ids() {
        return this.device.id.split(',');
    }

    get hasIds() {
        return this.ids && this.ids.length > 0;
    }

    get deviceName() {
        const desc = this.device.description;
        const customName = this.device.customName;

        if (customName && customName.length > 0) {
            return `${customName}, ${desc}`;
        }

        return desc;
    }

    checkIsCompleted() {
        const idCount = this.ids.length;
        const fileCount = Object.keys(this.selectedFiles).length;
        this.isCompleted = idCount === fileCount;
    }

    onFileChanged(id, files) {
        if (files) {
            this.selectedFiles[id] = files[0];
        } else {
            // Clear selected file
            delete this.selectedFiles[id];
        }

        this.checkIsCompleted();
        this.$emit('change', this.selectedFiles);
    }

    onSubmit() {
        this.$emit('close', this.selectedFiles);
    }

    onClose() {
        this.$emit('close');
    }
}
</script>
